import { Moment } from "moment";

import { LinkObject } from "@teamprevent/common/model";
import { FileAnswer } from "@teamprevent/common/questionnaires/model";
import { ImmunisationListModel } from "@teamprevent/common/immunisation/models";

import { ImmunisationTypeState } from "../../crud/immunisationType";

import { State as RouterState } from "redux-little-router";

export type Immunisation = ImmunisationListModel & ImmunisationDetailModel;

export interface ImmunisationDetailModel extends ImmunisationListModel {
    ohCase?: LinkObject;
    evidence?: FileAnswer[];
}

export interface ImmunisationCreateModel {
    notes: string;
    immunisationTypeName: string;
    // LocalDate
    dateCompleted: Moment;
    recordType: string;
    outcome: string;
    identityValidation: boolean;
    completedByName: string;
}

export interface ImmunisationAndEvidenceCreateModel extends ImmunisationCreateModel {
    evidence?: FileAnswer[];
}

export interface ImmunisationEditModel extends ImmunisationAndEvidenceCreateModel {
    id: string;
}

export interface ImmunisationsState {
    immunisations: ImmunisationListModel[];
}

export enum EppDecision {
    eppCleared = "eppCleared",
    nonEppCleared = "nonEppCleared"
}

export const EppDecisions = [
    { text: "EPP Cleared", value: EppDecision.eppCleared },
    { text: "Non EPP Cleared", value: EppDecision.nonEppCleared },
];

export type AppState = ImmunisationsState & RouterState & ImmunisationTypeState;

export enum Covid19VaccinationStatus {
    ClearedWith2Covid19Vaccinations = "ClearedWith2Covid19Vaccinations",
    PartiallyCovid19Vaccinated = "PartiallyCovid19Vaccinated",
    EmployeeNotCovid19VaccinatedButBookedFor1stVaccine = "EmployeeNotCovid19VaccinatedButBookedFor1stVaccine",
    EmployeeNotCovid19Vaccinated = "EmployeeNotCovid19Vaccinated",
    EmployeeNotCovid19VaccinatedAndExemptFromVaccination = "EmployeeNotCovid19VaccinatedAndExemptFromVaccination",
    ConsentNotProvidedToShareCovid19VaccinationStatus = "ConsentNotProvidedToShareCovid19VaccinationStatus"
}

export const Covid19VaccinationStatuses = [
    {
        text: "Cleared with 2 COVID-19 vaccinations",
        value: Covid19VaccinationStatus.ClearedWith2Covid19Vaccinations
    },
    {
        text: "Partially COVID-19 vaccinated",
        value: Covid19VaccinationStatus.PartiallyCovid19Vaccinated
    },
    {
        text: "Employee is not COVID-19 vaccinated but is booked / plans to book for 1st COVID-19 vaccine",
        value: Covid19VaccinationStatus.EmployeeNotCovid19VaccinatedButBookedFor1stVaccine
    },
    {
        text: "Employee is not COVID-19 vaccinated",
        value: Covid19VaccinationStatus.EmployeeNotCovid19Vaccinated
    },
    {
        text: "Employee is not COVID-19 vaccinated and is exempt from vaccination",
        value: Covid19VaccinationStatus.EmployeeNotCovid19VaccinatedAndExemptFromVaccination
    },
    {
        text: "Consent not provided to share COVID-19 vaccination status",
        value: Covid19VaccinationStatus.ConsentNotProvidedToShareCovid19VaccinationStatus
    }
];

export { immunisationTypesAndOutcomes } from "./immunisationTypesAndOutcomes";
